module.exports = "/_next/static/images/HeroMobile@2x-9f018ee9d78f7c3347574d632a0f92ff.webp";